import { useCallback, useState } from "react";
import { stages, stageTimes } from "../constants";

export const useStages = () => {
  const [currentIndex, setCurrentIndex] = useState(4);

  const currentStage = stages[currentIndex];
  const currentStageLength = stageTimes[currentStage] ?? 50000;
  const maxStageLength = Math.max(...Object.values(stageTimes));
  const isLastStage = currentIndex === stages.length - 1;
  const nextStage = isLastStage ? stages[0] : stages[currentIndex + 1];

  const goNextStage = useCallback(() => {
    setCurrentIndex((prev) => (prev === stages.length - 1 ? 0 : prev + 1));
  }, []);

  const goFirstStage = () => {
    setCurrentIndex(0);
  };

  return {
    currentStage,
    currentStageIndex: currentIndex,
    currentStageLength,
    isLastStage,
    maxStageLength,
    goNextStage,
    goFirstStage,
    nextStage,
  };
};
